import { useEffect } from 'react'
import cn from 'classnames'
import PropTypes from 'prop-types'
import { map } from 'lodash'
import { useSelector, useDispatch } from 'react-redux'
import smoothscroll from 'smoothscroll-polyfill'

import Checkbox from '../Checkbox'
import Section from '../Section'
import Loader from '../Loader'
import { ReactComponent as IconEmptyImage } from '../../assets/icons/IconEmptyImage.svg'

import { setScreenScrollOffset } from 'store/AppState/actions'
import { getScreenScrollOffset } from 'store/AppState/selector'
import { createItemImageUrl } from 'utils/items/createItemImageUrl'

const ItemList = ({
  data,
  history,
  itemsSelected,
  setItemsSelected,
}) => {
  const isLoading = useSelector(
    (state) => state?.items?.isLoading ?? false
  )

  useEffect(() => {
    smoothscroll.polyfill()
    if (!isLoading) {
      window.scrollTo({ top: offsetToScroll })
    }
  }, [isLoading])

  const dispatch = useDispatch()

  const offsetToScroll = useSelector((state) =>
    getScreenScrollOffset(state, 'items')
  )

  const handleItemSelect = (isItemChecked, uuid) => {
    const unselectItem = itemsSelected.filter(
      (selectedUuid) => selectedUuid !== uuid
    )

    isItemChecked
      ? setItemsSelected([...unselectItem])
      : setItemsSelected([...itemsSelected, uuid])
  }

  const setItemsScrollPosition = () => {
    dispatch(
      setScreenScrollOffset({
        screen: 'items',
        offset: window.scrollY,
      })
    )
  }

  const renderItem = (item) => {
    const availabilityOptions = {
      available: 'Available',
      low_on_inventory: 'Low On Inventory',
      unavailable: 'Unavailable',
    }
    const { uuid, name, price, productSku, inventoryState } = item
    const itemStateOnInventoryFormatted =
      availabilityOptions[inventoryState]
    const convertToNumberPrice = Number(price)
    const isItemChecked = itemsSelected.includes(uuid)
    const itemClassNames = cn('item', {
      '-selected': isItemChecked,
    })

    return (
      <div key={uuid} className={itemClassNames}>
        <Checkbox
          checked={isItemChecked}
          onChange={() => handleItemSelect(isItemChecked, uuid)}
        />
        <div
          className="row"
          onClick={() => {
            setItemsScrollPosition()
            history.push(`/items/${uuid}`)
          }}
        >
          <div className="item-info-wrapper">
            <span className="name">{name}</span>
          </div>
          <div className="item-info-wrapper">
            <object
              data={createItemImageUrl(productSku)}
              type="image/webp"
              className="item__image -empty-image"
            >
              <IconEmptyImage />
            </object>
          </div>
          <div className="item-info-wrapper">
            {convertToNumberPrice.toLocaleString('en-US', {
              style: 'currency',
              currency: 'USD',
            })}
          </div>
          <div className="item-info-wrapper">{productSku}</div>
          <div className="item-info-wrapper">
            <span
              className={cn({
                'item-info-wrapper__available':
                  inventoryState === 'available',
                'item-info-wrapper__low':
                  inventoryState === 'low_on_inventory',
                'item-info-wrapper__unavailable':
                  inventoryState === 'unavailable',
              })}
            ></span>
            {itemStateOnInventoryFormatted}
          </div>
        </div>
      </div>
    )
  }

  return isLoading ? (
    <Loader />
  ) : (
    <Section className="item-list">{map(data, renderItem)}</Section>
  )
}

ItemList.defaultProps = {
  data: [],
  history: {},
}

ItemList.propTypes = {
  data: PropTypes.arrayOf(PropTypes.shape({})),
  history: PropTypes.shape({
    push: PropTypes.func,
  }),
}

export default ItemList
